import { HELP_REQUEST_RECEIVED, HELP_REQUEST_DELETED, HELP_REQUEST_UNLOADED } from './types'

export default function help(state = {}, action = {}){
  switch (action.type) {
    case HELP_REQUEST_RECEIVED:
      return action.data
    case HELP_REQUEST_DELETED:
      return {}
    case HELP_REQUEST_UNLOADED:
      return {}
    default:
      return state;
  }
}
